import React, { useMemo } from 'react';
import { Breadcrumb, Button } from 'antd';

import { dayFormatType, formatDay } from '~helpers/day';
import generatePath from '~settings/routing';
import { orderReceivableStatus } from '~constants/order';

export default function Header({ orderInfo = {}, t, history, handleOpenUpdateModal = () => {} }) {
  const showUpdateStatusButton = useMemo(
    () =>
      [
        orderReceivableStatus.READY_FOR_APPROVAL,
        orderReceivableStatus.PENDING_APPROVAL,
        orderReceivableStatus.PENDING_INVOICE,
        orderReceivableStatus.INVOICED,
        orderReceivableStatus.PARTIALLY_PAID,
      ].includes(orderInfo?.status),
    [orderInfo.status],
  );

  const handleGoBack = () => {
    history.push(generatePath('reconciliation.order'));
  };

  return (
    <div className="header">
      <Breadcrumb>
        <Breadcrumb.Item className="breadcrumb-link" onClick={handleGoBack}>
          {t('cms.reconciliation.lead_generation.header.title')}
        </Breadcrumb.Item>
        <Breadcrumb.Item>{`${orderInfo?.order?.student?.passportFirstName} ${
          orderInfo?.order?.student?.passportMiddleName ?? ''
        } ${orderInfo?.order?.student?.passportLastName}’s Booking`}</Breadcrumb.Item>
      </Breadcrumb>
      <div className="title-wrapper">
        <span className="title-left">{`${orderInfo?.order?.referenceId} - ${
          orderInfo?.order?.student?.passportFirstName
        } ${orderInfo?.order?.student?.passportMiddleName ?? ''} ${
          orderInfo?.order?.student?.passportLastName
        }`}</span>
        <If condition={showUpdateStatusButton}>
          <Button type="primary" onClick={() => handleOpenUpdateModal(orderInfo)}>
            Update Status
          </Button>
        </If>
      </div>

      <div className="header-content__wrapper">
        <div className="header-content__left">
          <div className="form">
            <span className="label">Booking created date: </span>
            <span className="value">
              {orderInfo?.order?.createdAt
                ? formatDay(dayFormatType.UKFORMAT, orderInfo?.order?.createdAt)
                : '-'}
            </span>
          </div>
          <div className="form">
            <span className="label">Booking complete date: </span>
            <span className="value">
              {orderInfo?.order?.paidAt
                ? formatDay(dayFormatType.UKFORMAT, orderInfo?.order?.paidAt)
                : '-'}
            </span>
          </div>
          <div className="form">
            <span className="label">Currency: </span>
            <span className="value">{orderInfo?.currency ?? '-'}</span>
          </div>
          <div className="form">
            <span className="label">Listing Plan: </span>
            <span className="value">
              {orderInfo?.order?.bookingJourney
                ? t(
                    `cms.reconciliation.lead_generation.table.filter.status.${orderInfo?.order?.bookingJourney?.toLowerCase()}`,
                  )
                : '-'}
            </span>
          </div>
        </div>
        <div className="header-content__right">
          <p className="title">Current Reconciliation Status</p>
          <p className="status">
            {orderInfo?.status
              ? t(`cms.reconciliation.lead_generation.status.${orderInfo?.status?.toLowerCase()}`)
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
}
